import {ACTION_TYPES} from 'constants/ActionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_DATA_BREADCRUMB:
      return {
        ...state,
        hasBreadcrumb: action.hasBreadcrumb,
        data: action.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/breadcrumb.js